import type { OrderStatus } from '@/components/order/OrderStatusChip/OrderStatusChip';
import { outOfBandThemeColors } from '@/theme/colors';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LockClockIcon from '@mui/icons-material/LockClock';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';

import type { SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material';

interface StatusChipConfig {
  icon: typeof SvgIcon;
  color: string;
  backgroundColor: string;
  hideBorder?: boolean;
}

type OrderStatusChipConfigByStatus = Record<OrderStatus, StatusChipConfig>;

export default function useOrderStatusChipConfig() {
  const theme = useTheme();

  const config: OrderStatusChipConfigByStatus = {
    orderPlaced: {
      icon: DomainVerificationIcon,
      color: theme.palette.success.main,
      backgroundColor: theme.palette.success.light,
    },
    shippedByPharmacy: {
      icon: LocalShippingOutlinedIcon,
      color: theme.palette.info.dark,
      backgroundColor: theme.palette.info.light,
    },
    delivered: {
      icon: CheckCircleOutlineOutlinedIcon,
      color: theme.palette.success.main,
      backgroundColor: outOfBandThemeColors.uMeds.merino100,
    },
    dispenseInterval: {
      icon: LockClockIcon,
      color: theme.palette.info.main,
      backgroundColor: theme.palette.info.light,
    },
    cancelled: {
      icon: CancelOutlinedIcon,
      color: theme.palette.error.main,
      backgroundColor: outOfBandThemeColors.uMeds.merino100,
    },
    splitOrder: {
      icon: ArticleOutlinedIcon,
      color: '#F57F17', // yellow.900
      backgroundColor: '#FFFDE7', // yellow.50
    },
    refunded: {
      icon: CurrencyExchangeOutlinedIcon,
      color: theme.palette.text.primary,
      backgroundColor: outOfBandThemeColors.uMeds.merino100,
    },
    readyForCollection: {
      icon: StoreOutlinedIcon,
      color: '#9C27B0', // purple.500
      backgroundColor: '#F3E5F5', // purple.50
    },
    collected: {
      icon: CheckCircleOutlineOutlinedIcon,
      color: theme.palette.success.main,
      backgroundColor: outOfBandThemeColors.uMeds.merino100,
    },
  };

  return {
    config,
  };
}
